import { IReducersMap, reducer } from '../../standard-actions/reducers';
import {
    TPAMS_REPORTS_LOAD_SUMMARY,
    TPAMS_REPORTS_LOAD_REPORTS,
    TPAMS_REPORTS_LOAD_MONTHLY_REPORTS
} from '../actions/action-types';
import { ITPAMSReportsState } from '../state';
import { initialState } from '../state/initial-state';
import { loadSummaryReducer, LoadSummaryAction } from './load-summary';
import { loadReportsReducer, LoadReportsAction } from './load-reports';
import { loadMonthlyReportsReducer, LoadMonthlyReportsAction } from './load-monthly-reports';

type TPAMSReportsAction = LoadSummaryAction | LoadReportsAction | LoadMonthlyReportsAction;

const reducersMap: IReducersMap<ITPAMSReportsState> = {
    [TPAMS_REPORTS_LOAD_SUMMARY]: loadSummaryReducer,
    [TPAMS_REPORTS_LOAD_REPORTS]: loadReportsReducer,
    [TPAMS_REPORTS_LOAD_MONTHLY_REPORTS]: loadMonthlyReportsReducer
};

export const TPAMSReportsReducer = reducer<ITPAMSReportsState, TPAMSReportsAction>(reducersMap, initialState);
